'use strict';
angular.module('resourceCenterVideoDetailModule', [])
    .controller('resourceCenterVideoDetailCtrl', ['$stateParams', '$scope', 'trsHttpService', '$sce', 'localStorageService', 'modalDialog', '$state', '$timeout', '$sessionStorage', function($stateParams, $scope, trsHttpService, $sce, localStorageService, modalDialog, $state, $timeout, $sessionStorage) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.channelName = $stateParams.channel === 'unknownchannel' ? undefined : $stateParams.channel;
            $scope.params = {
                'serviceid': 'jtcpg',
                'modelid': 'detailData',
                'guid': $stateParams.guid,
                'typeid': 'zyzx',
            };
            $scope.status = {
                showSourceSite: '', // 显示来源名称
                listOpen: 'draftInfo', // 默认选中的属性信息
                attrDropdown: {
                    groupProcess: false, // 集团取签流程
                    groupEntityInfo: true, // 集团实体信息
                    authorInfo: false, // 作者信息
                    draftRelatedInfo: false, // 稿件关联信息
                    relevantDraft: false, // 相关稿件
                    groupReprint: false, // 集团转载
                    relatedHotwords: false, // 关联热点词
                    reprintMedia: false // 转载媒体
                },
                videoPlaying: false
            };
            $scope.data = {
                keywordsArray: [], // 关键词数组
                videoInfo: {}
            };
        }

        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, 'post').then(function(data) {
                if (data.result == 'success') {
                    $scope.detailIndexname = data.summary_info.indexName;
                    $scope.detailInfos = data.content[0];
                    urlFormat($scope.detailInfos);
                }
            });

            headPortrait();
        }

        function urlFormat(item) {
            var url = $sce.trustAsResourceUrl(item.PUBLIC_URL);
            item.value = {
                'streamsMap': {
                    'l': {
                        'httpURL': url
                    }
                }
            };
        }

        /**
         * [pageTurning description] 翻页 上一篇/下一篇
         * @param {int} direction [description]
         * @return {[type]} [description]
         */
        $scope.pageTurning = function(direction) {
            var temp = localStorageService.get('resourceVideoDetail');
            var pageTurningData = typeof (temp) === 'object' ? temp : JSON.parse(temp);
            var toPageData;
            for (var i = 0; i < pageTurningData.length; i++) {
                if (pageTurningData[i].ZB_GUID === $stateParams.guid || pageTurningData[i].GUID === $stateParams.guid) {
                    toPageData = pageTurningData[i + direction];
                    break;
                }
            }
            if (!toPageData) {
                var directionTxt = direction === 1 ? '下' : '上';
                modalDialog.alertType('没有' + directionTxt + '一篇了！', '', 'warning', false);
                return;
            }
            $state.go($state.current.name, {
                guid: toPageData.ZB_GUID || toPageData.GUID,
                channel: toPageData.channel,
            }, {
                reload: true
            });
        };

        /**
         * [headPortrait description] 获取用户头像
         * @return {[type]} [description]
         */
        function headPortrait() { // detail
            var params = {
                serviceid: 'mlf_extuser',
                methodname: 'getUserHeadPic'
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.headPic = data.USERHEAD[0].PERPICURL == '' ? './images/user_icon.jpg' : data.USERHEAD[0].PERPICURL;
            });
        }

        /**
         * [playVideo description] 视频播放
         * @return {[type]} [description]
         */
        $scope.playVideo = function() {
            $scope.status.videoPlaying = true;
            $timeout(function() {$('video')[0].play();});
        };

        /**
         * [logout description] 退出登录
         * @return {[type]} [description]
         */
        $scope.logout = function() {
            // localStorageService.remove('currLoginUser'); // session改变
            $sessionStorage.remove('currLoginUser');
            // localStorageService.remove('mlfCachedUser'); // session改变
            $sessionStorage.remove('mlfCachedUser');
            $('#unreadPrompt_js').hide(); // 关闭传稿提示框
            // $scope.checkLoginOutIframeSrc = $location.path().split("/")[0] + "/wcm/logout.jsp";
            $.ajax({
                url: '/wcm/logout.jsp',
                method: 'get',
                async: false,
                success: function() {},
                error: function() {
                    // modalDialog.alertType('退出异常！',"", "warning", false);
                }
            });
            $state.go('front.editctr.iWo.personalManuscript', {}, { reload: true });
        };
    }]);
